import { ArrowRight } from "lucide-react";

const metrics = [
  ["Participation", "Signal density across the branch"],
  ["Recognition", "Continuous appreciation cadence"],
  ["Momentum", "Streaks & recovery patterns"],
  ["Collaboration", "Cross-team assist behaviour"],
  ["Business Performance", "Recognized contribution → outcomes"],
];

export default function Pilot() {
  return (
    <section
      id="pilot"
      data-testid="pilot-section"
      className="relative py-28 lg:py-36 border-b border-white/5 bg-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#dc2626] mb-4 flex items-center gap-3">
              <span className="w-8 h-px bg-[#dc2626]" /> 08 · The Pilot Program
            </div>
            <h2 className="font-display uppercase font-black text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              Start small.
              <br />
              <span className="text-neutral-500">Prove everything.</span>
              <br />
              <span className="text-[#dc2626]">Then scale.</span>
            </h2>
            <p className="mt-8 text-neutral-400 leading-relaxed max-w-lg">
              A single branch. Fifty employees. Thirty days. Enough to prove the engine
              against your actual behaviour — with a full debrief report at the end.
            </p>

            <div className="mt-10 flex flex-wrap gap-4">
              <a
                href="#contact"
                data-testid="pilot-cta"
                className="inline-flex items-center gap-3 bg-[#dc2626] hover:bg-[#991b1b] px-8 py-4 font-mono text-xs uppercase tracking-[0.25em] font-semibold transition-all hover:translate-y-[-2px] hover:shadow-[0_12px_30px_rgba(220,38,38,0.5)]"
              >
                Request Pilot Briefing
                <ArrowRight size={16} />
              </a>
            </div>
          </div>

          <div className="col-span-12 lg:col-span-6">
            <div className="border border-white/10 bg-[#0a0a0a] p-8">
              <div className="grid grid-cols-3 gap-px bg-white/10 border border-white/10 mb-8">
                {[
                  ["01", "BRANCH", "Or single office"],
                  ["50+", "EMPLOYEES", "Live participants"],
                  ["30", "DAYS", "End-to-end cycle"],
                ].map(([n, k, d], i) => (
                  <div key={i} className="bg-black p-6 text-center">
                    <div className="font-display font-black text-4xl md:text-5xl leading-none">
                      {n}
                    </div>
                    <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-[#f59e0b]">
                      {k}
                    </div>
                    <div className="mt-1 text-[11px] text-neutral-500">{d}</div>
                  </div>
                ))}
              </div>

              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 mb-4">
                METRICS · REPORTED TO LEADERSHIP
              </div>
              <ul className="divide-y divide-white/5">
                {metrics.map(([k, d], i) => (
                  <li
                    key={i}
                    data-testid={`pilot-metric-${i}`}
                    className="py-3 flex items-start justify-between gap-6"
                  >
                    <span className="font-display uppercase font-bold tracking-tight text-white">
                      {k}
                    </span>
                    <span className="text-xs text-neutral-500 text-right max-w-[220px]">
                      {d}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
